import React, { Component } from 'react'

import { Query } from 'react-apollo'
import { connect } from 'react-redux'
import gql from 'graphql-tag'
import featureFlags from '../../utils/featureFlags'

import SubmissionsListFeedTable from './SubmissionsListFeedTable'
import { validateDate } from '../../utils/checkBindDate';


const SUBMISSION_LIST_SEARCH_QUERY = gql`
  query SubmissionListSearch($search: SearchInput, $filters: FiltersInput, $pagination: PaginationInput, $sort: SortInput) {
    submissionSearch(search: $search, filters: $filters, pagination: $pagination, sort: $sort) {
      totalCount
      edges { node { id bindInitiated isBinded projectAddress { address city state } primaryInsuredName projectName type quoteStatus manualQuoteStatus manualQuoteStatusUpdatedAt primaryPolicyNumber totalPremium commission contactInfo { email } brokerage { agencyCode name } createdAt edgeNumber workflowStatus updatedAt anticipatedStartDate anticipatedFinishDate transactionStatus } }
    }
  }
`

class SubmissionListFeed extends Component {
  constructor(props) {
    super(props)

    this.state = {
      phrase: null,
      isMine: true,
      isNotQuoted: false,
      isMissingEdgeNumber: false,
      isActive: true,
      isPriced: false,
      isReferred: false,
      isExpired: false,
      isPending: false,
      isUnknown: false,
      isProcessed: false,
      isExpiringSoon: false,
      productType: null,
      brokerId: null,
      currentPage: 1,
      sizePerPage: 7,
      sortField: {field: "updatedAt", order: "desc" }
    }
  }

  handleSearchChange = (searchText) => {
    this.resetFilter();
    this.setState({
      currentPage: 1,
      phrase: searchText.length ? searchText : null
    })
  }

  handlePageChange = (currentPage, sizePerPage) => {
    this.setState({ currentPage, sizePerPage })
  }

  handleChangeIsMissingEdgeNumber = async () => {
    this.resetSearch()
    this.setState({
      currentPage: 1,
      isMissingEdgeNumber: !this.state.isMissingEdgeNumber
    })
  }

  handleChangeIsMine = async () => {
    this.resetSearch()
    this.setState({
      currentPage: 1,
      isMine: !this.state.isMine
    })
  }

  handleChangeIsNotQuoted = async () => {
    this.resetSearch()
    this.setState({
      currentPage: 1,
      isNotQuoted: !this.state.isNotQuoted
    })
  }

  handleChangeBrokerId = async (brokerId) => {
    if (this.props.isUnderwriter) {
      this.resetSearch()
      this.setState({
        currentPage: 1,
        brokerId,
      })
    }
  }

  handleSort = async (field, order) => {
    this.setState({
      sortField: {field, order}
    })
  }

  handleChangeIsActive = async () => {
    this.resetSearch()
    this.setState({
      currentPage: 1,
      isActive: !this.state.isActive
    })
  }

  handleChangeIsPriced = async () => {
    this.resetSearch()
    this.setState({
      currentPage: 1,
      isPriced: !this.state.isPriced
    })
  }

  handleChangeIsReferred = async () => {
    this.resetSearch()
    this.setState({
      currentPage: 1,
      isReferred: !this.state.isReferred
    })
  }

  handleChangeIsExpired = async () => {
    this.resetSearch()
    this.setState({
      currentPage: 1,
      isExpired: !this.state.isExpired
    })
  }

  handleChangeIsPending = async () => {
    this.resetSearch()
    this.setState({
      currentPage: 1,
      isPending: !this.state.isPending
    })
  }

  handleChangeIsUnknown = async () => {
    this.resetSearch()
    this.setState({
      currentPage: 1,
      isUnknown: !this.state.isUnknown
    })
  }

  handleChangeIsProcessed = async() => {
    this.resetSearch()
    this.setState({
      currentPage: 1,
      isProcessed: !this.state.isProcessed
    })
  }

  resetFilter = async () => {
    this.setState({
      isMine: false,
      isMissingEdgeNumber: false,
      isActive: false,
      isNotQuoted: false,
      isPriced: false,
      isReferred: false,
      isUnknown: false,
      isExpired: false,
      isPending: false,
      isProcessed: false,
      brokerId: null,
      isExpiringSoon: false
    })
  }

  resetSearch = async () => {
    this.setState({
      phrase: null
    })
  }

  getDefaultSearch = async () => {
    this.setState({
      phrase: null,
      isExpiringSoon: false,
      isMine: true,
      isMissingEdgeNumber: false,
      isActive: true,
      isNotQuoted: false,
      isPriced: false,
      isReferred: false,
      isUnknown: false,
      isExpired: false,
      isPending: false,
      isProcessed: false,
      brokerId: null
    })
  }

  resetAllFilters = () => this.setState({
    phrase: null,
    isExpiringSoon: false,
    isMine: false,
    isMissingEdgeNumber: false,
    isActive: false,
    isNotQuoted: false,
    isPriced: false,
    isReferred: false,
    isUnknown: false,
    isExpired: false,
    isPending: false,
    isProcessed: false,
    brokerId: null
  })

  handleChangeIsExpiringSoon = async () => {
    this.resetSearch();
    this.setState({
      currentPage: 1,
      isExpiringSoon: !this.state.isExpiringSoon
    })
  }

  

  render() {
    const { isUnderwriter, fetchClearedSubmissions, getDownloadQuoteSubmission, getDownloadQuoteSpecimenSubmission } = this.props
    const { phrase, brokerId, isMine, isMissingEdgeNumber, isActive, isPriced, isReferred, isExpired, isPending, isUnknown, isNotQuoted, isProcessed, isExpiringSoon, sortField, productType, currentPage, sizePerPage } = this.state

    const variables = {
      search: {
        phrase
      },
      filters: {
        isMissingEdgeNumber,
        isMine,
        isNotQuoted,
        isActive: isActive,
        isPriced: isPriced,
        isReferred: isReferred,
        isExpired: isExpired,
        isPending,
        isUnknown,
        isProcessed: isProcessed,
        isExpiringSoon,
        productType,
        brokerId,
      },
      pagination: {
        from: (currentPage - 1) * sizePerPage,
        size: sizePerPage,
      },
      sort: {
        ...sortField
      }
    }

    return (
      <Query query={SUBMISSION_LIST_SEARCH_QUERY} variables={variables} fetchPolicy="cache-and-network">
        {({ loading, error, data = {}, refetch }) => {
          const { submissionSearch: { totalCount, edges = [] } = {} } = data
            return (
            <SubmissionsListFeedTable
              loading={loading}
              error={error}
              isUnderwriter={isUnderwriter}
              onChangeIsMine={this.handleChangeIsMine}
              onChangeIsActive={this.handleChangeIsActive}
              onChangeIsPriced={this.handleChangeIsPriced}
              onChangeIsReferred={this.handleChangeIsReferred}
              onChangeIsExpired={this.handleChangeIsExpired}
              onChangeIsPending={this.handleChangeIsPending}
              onChangeIsUnknown={this.handleChangeIsUnknown}
              onChangeIsNotQuoted={this.handleChangeIsNotQuoted}
              onChangeIsProcessed={this.handleChangeIsProcessed}
              onChangeIsExpiringSoon={this.handleChangeIsExpiringSoon}
              onChangeIsMissingEdgeNumber={this.handleChangeIsMissingEdgeNumber}
              onSearchChange={this.handleSearchChange}
              onPageChange={this.handlePageChange}
              onBrokerIdChange={this.handleChangeBrokerId}
              onSortChange={this.handleSort}
              phrase={phrase}
              brokerId={brokerId}
              totalCount={totalCount}
              sizePerPage={sizePerPage}
              currentPage={currentPage}
              data={edges}
              refetchSubmissions={refetch}
              fetchClearedSubmissions={fetchClearedSubmissions}
              getDownloadQuoteSubmission={getDownloadQuoteSubmission}
              getDownloadQuoteSpecimenSubmission={getDownloadQuoteSpecimenSubmission}
              isMissingEdgeNumber={isMissingEdgeNumber}
              isMine={isMine}
              isActive={isActive}
              isPriced={isPriced}
              isReferred={isReferred}
              isExpired={isExpired}
              isPending={isPending}
              isUnknown={isUnknown}
              isNotQuoted={isNotQuoted}
              isProcessed={isProcessed}
              isExpiringSoon={isExpiringSoon}
              sortField={sortField}
              getDefaultSearch={this.getDefaultSearch}
              resetAllFilters={this.resetAllFilters}
              underwriter={this.props.underwriter}
            />
          )
        }}
      </Query>
    )
  }
}

const mapStateToProps= (store) => {
  return {
      underwriter: store.underwriter
  }
}
export default connect(mapStateToProps) (SubmissionListFeed);



